// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"529057da","158":"85fa4243","186":"7d81e6d3","237":"d8ed5a81","525":"597479f3","533":"9a526677","574":"404ff0f5","621":"323f10ce","631":"b5bee5c0","883":"5c449231","955":"2c504008"}[chunkId] + ".chunk.js";
};